import { withTranslations } from 'hooks/useTranslations'
import Component from './DeliveryInfo'
import { graphql, useStaticQuery } from 'gatsby'

declare global {
  interface Snippets {
    deliveryInfo: {
      available_furniture: void
      available: void
      available_meterware: void
      closeout_exceed: {
        stock: string
        amount: string
      }
      unit: {
        packUnit: string
      }
      shippable_with_reduced_stock: {
        stock: string
      }
      shippable_soon: {
        stock: string
      }
      shippable_soon_furniture: {
        stock: string
      }
      shippable_currently_not: void
      full_delivery_at_date_weeks: {
        stock: string
        weeks: string
      }
      full_delivery_at_date_months: {
        stock: string
        months: string
      }
      no_stock_with_delivery_in_weeks: {
        weeks: string
      }
      no_stock_with_delivery_in_months: {
        months: string
      }
      full_delivery_at_date_weeks_furniture: {
        stock: string
        weeks: string
      }
      full_delivery_at_date_months_furniture: {
        stock: string
        months: string
      }
      no_stock_with_delivery_in_weeks_furniture: {
        weeks: string
      }
      no_stock_with_delivery_in_months_furniture: {
        months: string
      }
      shipping_by_partner: void
      temporary_delisted: void
      closeout_exceed_checkout: {
        stock: string
      }
    }
  }
}

export default withTranslations(Component, () =>
  useStaticQuery(graphql`
    query deliveryInfo {
      available_furniture: snippet(
        group: "deliveryInfo"
        name: "available_furniture"
      )
      available_meterware: snippet(
        group: "deliveryInfo"
        name: "available_meterware"
      )
      available: snippet(group: "deliveryInfo", name: "available")
      closeout_exceed: snippet(group: "deliveryInfo", name: "closeout_exceed")
      shippable_with_reduced_stock: snippet(
        group: "deliveryInfo"
        name: "shippable_with_reduced_stock"
      )
      shippable_soon: snippet(group: "deliveryInfo", name: "shippable_soon")
      shippable_soon_furniture: snippet(
        group: "deliveryInfo"
        name: "shippable_soon_furniture"
      )
      shippable_currently_not: snippet(
        group: "deliveryInfo"
        name: "shippable_currently_not"
      )
      full_delivery_at_date_weeks: snippet(
        group: "deliveryInfo"
        name: "full_delivery_at_date_weeks"
      )
      full_delivery_at_date_months: snippet(
        group: "deliveryInfo"
        name: "full_delivery_at_date_months"
      )
      no_stock_with_delivery_in_weeks: snippet(
        group: "deliveryInfo"
        name: "no_stock_with_delivery_in_weeks"
      )
      no_stock_with_delivery_in_months: snippet(
        group: "deliveryInfo"
        name: "no_stock_with_delivery_in_months"
      )
      full_delivery_at_date_weeks_furniture: snippet(
        group: "deliveryInfo"
        name: "full_delivery_at_date_weeks_furniture"
      )
      full_delivery_at_date_months_furniture: snippet(
        group: "deliveryInfo"
        name: "full_delivery_at_date_months_furniture"
      )
      no_stock_with_delivery_in_weeks_furniture: snippet(
        group: "deliveryInfo"
        name: "no_stock_with_delivery_in_weeks_furniture"
      )
      no_stock_with_delivery_in_months_furniture: snippet(
        group: "deliveryInfo"
        name: "no_stock_with_delivery_in_months_furniture"
      )
      shipping_by_partner: snippet(
        group: "deliveryInfo"
        name: "shipping_by_partner"
      )
      temporary_delisted: snippet(
        group: "deliveryInfo"
        name: "temporary_delisted"
      )
      closeout_exceed_checkout: snippet(
        group: "deliveryInfo"
        name: "closeout_exceed_checkout"
      )
    }
  `)
)
